import { FILE_STATES, logger } from "@rpldy/shared";
import { persistResumable } from "../resumableStore";
import createUpload from "./initTusUpload/createUpload";
import finalizeParallelUpload from "./finalizeParallelUpload";
import { addLocationToResponse } from "./utils";
const doChunkedUploadForItem = (items, url, sendOptions, onProgress, tusState, chunkedSender, initData) => {
  const {
    options
  } = tusState.getState();
  const item = items[0];
  logger.debugLog(`tusSender.handler: init request finished. sending item ${item.id} as chunked`, initData);
  let usedSendOptions = sendOptions;
  if (initData.isNew && initData.uploadUrl) {
    persistResumable(item, initData.uploadUrl, options);
  }
  if (initData.canResume || options.sendDataOnCreate && initData.offset) {
    usedSendOptions = {
      ...sendOptions,
      startByte: initData.offset
    };
  }
  const chunkedResult = chunkedSender.send(items, url, usedSendOptions, onProgress);
  tusState.updateState(state => {
    state.items[item.id].abort = chunkedResult.abort;
  });
  return +options.parallel > 1 ? finalizeParallelUpload(item, url, tusState, usedSendOptions, chunkedResult.request) : addLocationToResponse(chunkedResult.request, initData.uploadUrl);
};
const handleParallelizedChunkInit = (items, tusState, initData, parallelIdentifier) => {
  const item = items[0];
  if (initData.uploadUrl) {
    persistResumable(item, initData.uploadUrl, tusState.getState().options, parallelIdentifier);
  }
  logger.debugLog(`tusSender.handler: created upload for parallelized chunk: ${item.id}`);
  return Promise.resolve({
    status: 200,
    state: FILE_STATES.UPLOADING,
    response: "TUS server created upload for parallelized part"
  });
};
const handleTusUpload = (items, url, sendOptions, onProgress, tusState, chunkedSender, initRequest, isResume, parallelIdentifier) => initRequest.then(initData => {
  let request,
    resumeFailed = false;
  if (initData) {
    if (initData.isDone) {
      logger.debugLog(`tusSender.handler: resume found server has completed file for item: ${items[0].id}`, items[0]);
      request = addLocationToResponse(Promise.resolve({
        status: 200,
        state: FILE_STATES.FINISHED,
        response: {
          message: "TUS server has file"
        }
      }), initData.uploadUrl);
    } else if (!initData.isNew && !initData.canResume) {
      resumeFailed = true;
    } else if (parallelIdentifier) {
      request = handleParallelizedChunkInit(items, tusState, initData, parallelIdentifier);
    } else {
      request = doChunkedUploadForItem(items, url, sendOptions, onProgress, tusState, chunkedSender, initData);
    }
  } else {
    resumeFailed = isResume;
  }
  if (resumeFailed) {
    logger.debugLog(`tusSender.handler: resume init failed. Will try creating a new upload for item: ${items[0].id}`);
    const {
      request: createRequest
    } = createUpload(items[0], url, tusState, sendOptions);
    request = handleTusUpload(items, url, sendOptions, onProgress, tusState, chunkedSender, createRequest);
  }
  return request || Promise.resolve({
    status: 0,
    state: FILE_STATES.ERROR,
    response: "TUS initialize failed"
  });
});
export default handleTusUpload;